export const QueryParams = {
  search: 'searchQuery',
  sortBy: 'sortedBy',
  sortDirection: 'sortDirection',
};
